// import React, { useState, useCallback, useRef, useEffect } from 'react';
// import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';

// const containerStyle = {
//     width: '100%',
//     height: '400px',
// };

// const LocationPicker = ({ isMapShow, inputClassName, placeholder, label, className, isRequired, error }) => {
//     const [location, setLocation] = useState({ lat: 37.7749, lng: -122.4194 }); // Default to San Francisco
//     const [address, setAddress] = useState('');
//     const [map, setMap] = useState(null);
//     const [marker, setMarker] = useState(null);
//     const { isLoaded } = useLoadScript({
//         googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY, // Replace with your Google Maps API Key
//         libraries: ['places'],
//     });

//     const onLoad = useCallback((mapInstance) => {
//         setMap(mapInstance);
//     }, []);

//     const onMarkerDragEnd = (e) => {
//         const newLat = e.latLng.lat();
//         const newLng = e.latLng.lng();
//         setLocation({ lat: newLat, lng: newLng });

//         const geocoder = new window.google.maps.Geocoder();
//         geocoder.geocode({ location: { lat: newLat, lng: newLng } }, (results, status) => {
//             if (status === 'OK' && results[0]) {
//                 setAddress(results[0].formatted_address);
//             }
//         });
//     };

//     const onPlaceChanged = (autocomplete) => {
//         const place = autocomplete.getPlace();
//         if (place.geometry) {
//             setLocation({
//                 lat: place.geometry.location.lat(),
//                 lng: place.geometry.location.lng(),
//             });
//             setAddress(place.formatted_address);
//         }
//     };

//     const autocompleteRef = useRef(null);

//     useEffect(() => {
//         if (autocompleteRef.current) {
//             const autocomplete = new window.google.maps.places.Autocomplete(autocompleteRef.current);
//             autocomplete.setFields(['place_id', 'geometry', 'formatted_address']);
//             autocomplete.addListener('place_changed', () => onPlaceChanged(autocomplete));
//         }
//     }, []);

//     return isLoaded ? (
//         <div>
//             <div className={`flex flex-col !focus-visible:outline-none ${className}`}>
//                 {label && (
//                     <label className="text-sm mb-1">
//                         {label}
//                         {isRequired && (
//                             <span className="text-red-500 ml-1 font-bold">*</span>
//                         )}{" "}
//                     </label>
//                 )}
//                 <div >
//                     <input
//                         ref={autocompleteRef}
//                         type="text"
//                         placeholder={placeholder}
//                         style={{ width: '100%', padding: '10px' }}
//                         className={`py-3 px-2 text-sm border-2 border-gray-300 rounded-lg focus:outline-none !focus-visible:border-none focus:ring-0 focus:border-[#2BACE2] ${inputClassName}`}
//                     />
//                 </div>
//             </div>
//             {error && <div className="text-red-400 text-sm">{error}</div>}

//             {isMapShow && <GoogleMap
//                 id="location-picker-map"
//                 mapContainerStyle={containerStyle}
//                 center={location}
//                 zoom={15}
//                 onLoad={onLoad}
//                 onClick={(e) => onMarkerDragEnd(e)}
//             >
//                 <Marker
//                     position={location}
//                     draggable={true}
//                     onDragEnd={onMarkerDragEnd}
//                 />
//             </GoogleMap>}
//         </div>
//     ) : (
//         <div>Loading...</div>
//     );
// };

// export default LocationPicker;

import React from "react";
import Autocomplete from "react-google-autocomplete";
import { FiMapPin } from "react-icons/fi";

export default function LocationPicker({
  label,
  isRequired,
  onChange,
  placeholder,
  value,
  style,
}) {
  return (
    <div className="w-full" style={style}>
      {/* LABEL */}
      {label && (
        <label className="block text-sm font-semibold text-gray-700 mb-1">
          {label}
          {isRequired && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      
      <Autocomplete
        defaultValue={value}
        apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
        onPlaceSelected={(place) => onChange(place)}
        options={{ types: ["geocode"] }}
        placeholder={placeholder}
        style={{ height: 47 }}
        className="w-full border-2 text-sm border-gray-300 rounded-lg px-4 focus:outline-none focus:ring-0 focus:border-[#2BACE2]"
      />
    </div>
  );
}
